module.exports = __webpack_public_path__ + "img/cancel.e40370f1.svg";